<template>
  <div class="ui grid">
    <div class="row">
      <h3 class="ui huge header">Paid invoices</h3>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-form>
        <sui-form-field>
          <label>Begin of period</label>
          <input placeholder="Date" name="begin" type="date" v-model="begin" />
        </sui-form-field>
        <sui-form-field>
          <label>End of period</label>
          <input placeholder="Date" name="end" type="date" v-model="end" />
        </sui-form-field>
        <sui-form-field>
          <label>Show</label>
          <sui-dropdown selection name="licenseModelSelection" :options="licenseModelOptions"
            v-model="licenseModelSelection" />
        </sui-form-field>
        <sui-button type="button" positive v-on:click="submit">
          Display paid invoices for period
        </sui-button>
        <sui-button type="button" primary v-on:click="generateReport">
          Download report for period
        </sui-button>

      </sui-form>
    </div>
    <div class="row">
      <span>The total received payment for this period is&nbsp;
        {{ formatAsPrice(totalPaid) }} over {{ licenses.length }} invoice(s)</span>
    </div>
    <div class="row">
      <span>The total owed VAT for this period is&nbsp;
        {{ formatAsPrice(totalVat) }}</span>
    </div>
    <div class="row">
      <span></span>
    </div>
    <div class="row">
      <invoices-table v-bind:licenses="licenses" v-bind:actions="licensesActions" v-on:rowAction="rowAction"
        show-school="true" show-paid-date="true" />
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import { mapGetters } from 'vuex';
import InvoicesTable from '@/components/invoices/InvoicesTable';
import schoolsApi from '@/api/schools';

export default {
  name: 'PaidInvoices',
  components: { InvoicesTable },
  computed: {
    totalPaid() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.paid),
        0,
      );
    },
    totalVat() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.vat),
        0,
      );
    },
    ...mapGetters({
      licenses: 'licenses',
    }),
  },
  methods: {
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    getSelectedLicenseModels() {
      switch (this.licenseModelSelection) {
        case 'all':
          return ['perstudent', 'fixedprice', 'other'];
        case 'licenses':
          return ['perstudent', 'fixedprice'];
        case 'other':
          return ['other'];
        default:
          return ['perstudent', 'fixedprice', 'other'];
      }
    },
    submit() {
      this.$store.dispatch('getPaidLicenses', {
        begin: this.begin,
        end: this.end,
        licenseModels: this.getSelectedLicenseModels(),
      });
    },
    rowAction(action) {
      if (action.action === 'View') {
        // eslint-disable-next-line arrow-parens
        const license = this.licenses.find((l) => l.id === action.id);
        this.$router.push(`/school/details/${license.schoolId}?return=paid`);
      }
    },
    generateReport() {
      this.$store.dispatch('showLoader');
      schoolsApi
        .generatePaidLicensesReport({
          begin: this.begin,
          end: this.end,
          licenseModels: this.getSelectedLicenseModels()
        }
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
  },
  data() {
    return {
      licenseModelOptions: [
        { text: 'All', value: 'all' },
        { text: 'Licenses only', value: 'licenses' },
        { text: 'Other only', value: 'other' },
      ],
      begin: Moment().add(-1, 'year').format('YYYY-MM-DD'),
      end: Moment().format('YYYY-MM-DD'),
      licenseModelSelection: 'all',
      licensesActions: ['View'],
    };
  },
  created() {
    this.$store.dispatch('getPaidLicenses', {
      begin: this.begin,
      end: this.end,
      licenseModels: this.getSelectedLicenseModels()
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/PaidInvoices.vue